import { useState } from 'react';
import { ButtonTabContainer, StyledTab } from './styles';

interface TabProps {
  tab: Record<string, any>;
  onClick: (tab: any) => void;
  defaultTab?: string;
}

const CustomTabButton = ({ tab, onClick, defaultTab }: TabProps) => {
  const [activeTab, setActiveTab] = useState<string>(defaultTab || '');

  return (
    <ButtonTabContainer>
      {Object.entries(tab).map(([key, value]) => {
        return (
          <StyledTab
            active={activeTab === value}
            onClick={() => {
              setActiveTab(value);
              onClick(value);
            }}
            key={key}
          >
            {key}
          </StyledTab>
        );
      })}
    </ButtonTabContainer>
  );
};

export default CustomTabButton;
